import React from 'react';
import { ShieldCheck, Award, Clock, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-900 text-white overflow-hidden" data-id="element-213" data-mp="ejmplao41jva">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-214" data-mp="9kjwmolen43o">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-215" data-mp="4lqiqv27hb2z">
          <div className="space-y-8" data-id="element-216" data-mp="4n9wof0e3a1l">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-800/50 border border-brand-700 text-brand-accent text-sm font-semibold tracking-wide" data-id="element-217" data-mp="129h5y27n1qka">
              <ShieldCheck className="w-4 h-4" data-id="element-218" data-mp="x8bcg265lz9p" />
              <span data-id="element-219" data-mp="sai1kvtwoh33">California's Premier Asbestos Litigation Firm</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight" data-id="element-220" data-mp="nczsn5fw21v3">
              The Best Mesothelioma Lawyers in California
            </h1>

            <p className="text-lg md:text-xl text-brand-100 max-w-2xl leading-relaxed" data-id="element-221" data-mp="382fgbrjt9agi">
              If you or a loved one has been diagnosed with mesothelioma, you
              need California's top-rated legal representation. We have
              recovered over{' '}
              <span className="font-bold text-brand-accent" data-id="element-222" data-mp="3o6u534n0ghaa">$2 Billion</span>{' '}
              for asbestos victims statewide.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4" data-id="element-223" data-mp="3e8wjyq0g70lw">
              <a href="#contact" className="inline-flex justify-center items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-brand-900 px-8 py-4 rounded-md font-bold text-lg transition-all shadow-lg hover:shadow-xl" data-id="element-224" data-mp="3eb8zkwiqgyvs">
                Free Case Evaluation
                <ArrowRight className="w-5 h-5" data-id="element-225" data-mp="2viy4vpy8g78r" />
              </a>
              <a href="tel:805-770-9317" className="inline-flex justify-center items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white px-8 py-4 rounded-md font-bold text-lg transition-all" data-id="element-226" data-mp="2vj7sj6vt22ba">
                Call (805) 770-9317
              </a>
            </div>

            <div className="pt-8 border-t border-brand-800 space-y-6" data-id="element-227" data-mp="nbl2wm6daiaz">
              {/* Highlighted headline stat */}
              <div className="bg-brand-accent/10 border border-brand-accent/30 rounded-xl px-6 py-5 flex items-baseline gap-3" data-id="element-228" data-mp="ibgnz0l3xvmv">
                <span className="text-5xl md:text-6xl font-serif font-bold text-brand-accent leading-none" data-id="element-229" data-mp="deq92gl1h631">
                  $2 Billion+
                </span>
                <span className="text-base font-semibold text-white" data-id="element-230" data-mp="161b0fh1ili6l">
                  Recovered for California clients
                </span>
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-231" data-mp="114ki0n28mai0">
                <div className="flex flex-col gap-1" data-id="element-232" data-mp="x033b2aqine3">
                  <span className="text-2xl font-bold text-brand-accent" data-id="element-233" data-mp="3lsyu93l8eul6">
                    99%
                  </span>
                  <span className="text-sm text-brand-200" data-id="element-234" data-mp="3hqtz20f4xpwf">Success Rate</span>
                </div>
                <div className="flex flex-col gap-1" data-id="element-235" data-mp="1x9uk28qzz9md">
                  <span className="text-2xl font-bold text-brand-accent" data-id="element-236" data-mp="1x785hp5ovtun">
                    $0
                  </span>
                  <span className="text-sm text-brand-200" data-id="element-237" data-mp="269zfdkix2hk6">
                    Upfront Fees — No Win, No Fee
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Badge / Image Area */}
          <div className="hidden lg:block relative" data-id="element-238" data-mp="2fzaoh75szm82">
            <div className="absolute inset-0 bg-brand-800 rounded-2xl transform translate-x-4 translate-y-4" data-id="element-239" data-mp="2kync3u4i0xbp" />
            <img src="https://cdn.magicpatterns.com/uploads/jbAxSrToXGDqMPQiswBbNT/AdobeStock_159773953.jpg" alt="Raw asbestos fibers beside safety goggles and a respirator mask, illustrating occupational asbestos exposure" className="relative rounded-2xl shadow-2xl object-cover h-[500px] w-full border border-brand-800" data-id="element-240" data-mp="2ozz60bueo4pp" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white text-brand-900 p-6 rounded-xl shadow-xl max-w-xs border border-slate-100" data-id="element-241" data-mp="4acmxeox1t8h">
              <div className="flex items-start gap-4" data-id="element-242" data-mp="3vjrtqcn1hxsl">
                <div className="bg-brand-50 p-3 rounded-full" data-id="element-243" data-mp="e8imvqr5wpap">
                  <Award className="w-6 h-6 text-brand-accent" data-id="element-244" data-mp="9ah3f4ptqnyp" />
                </div>
                <div data-id="element-245" data-mp="98mivrigsxv5">
                  <h3 className="font-bold text-sm" data-id="element-246" data-mp="3hq0rlpbn1g6w">Top Ranked in CA</h3>
                  <p className="text-xs text-slate-500 mt-1" data-id="element-247" data-mp="3hnxtsj48uirm">
                    Recognized for excellence in asbestos litigation and
                    record-breaking verdicts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}